// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f098240b","453":"951eb20d","796":"6d180b90"}[chunkId] + ".chunk.js";
};